// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modalSkeleton_modal__cvu8- {
  border-radius: 25px;
}

.modalSkeleton_modal__cvu8- .btn-close {
  display: none;
}

.modalSkeleton_header__CVTZ4 {
  padding: 15px;
  background: var(--primary-color);
  position: static;
}

.modalSkeleton_body__NxRt4 {
  padding-top: 20px;
  padding-bottom: 20px;
  /* min-height: 380px; */
  height: auto;

  overflow-y: scroll;
}

.modalSkeleton_faq__1qIWq {
  padding-top: 20px;
  height: auto;
  padding-bottom: 0;
  height: 343px;
  overflow-y: scroll;
}

.modalSkeleton_modal__cvu8- .modal-content {
  position: relative;
}

.modalSkeleton_iconBox__MMdnW {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: -12px;
  top: -12px;
  z-index: 1050;
  border-radius: 50%;
  background-color: var(--white-color, #ffffff);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.modalSkeleton_iconBox__MMdnW:hover {
  transform: scale(1.08);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);
  background-color: #f8f9fa;
}

.modalSkeleton_iconBox__MMdnW svg {
  color: var(--black-color, #1a1a1a);
  width: 14px;
  height: 14px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Components/atoms/ModalSkeleton/modalSkeleton.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;;EAEZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,6CAA6C;EAC7C,0CAA0C;EAC1C,eAAe;EACf,qCAAqC;EACrC,iFAAiF;AACnF;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".modal {\n  border-radius: 25px;\n}\n\n.modal :global(.btn-close) {\n  display: none;\n}\n\n.header {\n  padding: 15px;\n  background: var(--primary-color);\n  position: static;\n}\n\n.body {\n  padding-top: 20px;\n  padding-bottom: 20px;\n  /* min-height: 380px; */\n  height: auto;\n\n  overflow-y: scroll;\n}\n\n.faq {\n  padding-top: 20px;\n  height: auto;\n  padding-bottom: 0;\n  height: 343px;\n  overflow-y: scroll;\n}\n\n.modal :global(.modal-content) {\n  position: relative;\n}\n\n.iconBox {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  right: -12px;\n  top: -12px;\n  z-index: 1050;\n  border-radius: 50%;\n  background-color: var(--white-color, #ffffff);\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n  cursor: pointer;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;\n}\n\n.iconBox:hover {\n  transform: scale(1.08);\n  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);\n  background-color: #f8f9fa;\n}\n\n.iconBox svg {\n  color: var(--black-color, #1a1a1a);\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modalSkeleton_modal__cvu8-`,
	"header": `modalSkeleton_header__CVTZ4`,
	"body": `modalSkeleton_body__NxRt4`,
	"faq": `modalSkeleton_faq__1qIWq`,
	"iconBox": `modalSkeleton_iconBox__MMdnW`
};
export default ___CSS_LOADER_EXPORT___;
